module.exports = __webpack_public_path__ + "img/gaoxin.2258112d.jpg";